export default function styles(theme) {
  return {
    section: {
      padding: "2rem 0",
    },

    image: {
      display: "flex",
      margin: "0 auto",
      width: 300,
      height: "auto",
    },
    title: {
      display: "block",
      width: "100%",
      textAlign: "center",
      fontWeight: 800,
      color: theme.palette.text.primary,
      fontSize: "3rem",
      marginTop: -20,
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2.5rem",
      },
    },
    description: {
      display: "block",
      fontSize: "1rem",
      textAlign: "left",
      width: "100%",
      color: theme.palette.text.tertiary,
      margin: "0 auto",
    },
    heroSection: {
      backgroundSize: "contain",
      marginBottom: 40,
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },

    btns: {
      display: 'flex',
      gap: 20,
      marginTop: 20,
    },

    secondaryTitle: {
      fontSize: "3rem",
      textAlign:"left",
      width: "100%",
      letterSpacing: "1px",
      color: theme.palette.text.primary,
      margin: "0rem",
      padding:"3rem 0rem",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2rem",
      },
    },
    heroPara:{
      textAlign: 'center',
      color: theme.palette.text.tertiary,
      maxWidth: "60%",
      margin: '10px auto',
      lineHeight:'1.6rem',
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    sTitle: {
      textAlign: 'left',
      color: theme.palette.text.tertiary,
      maxWidth: "60%",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    cardWrapper: {
      display: 'grid',
      gridTemplateColumns: "1fr 1fr",
      gap: 20,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    },
    benefitsWrapper: {
      display: 'grid',
      gridTemplateColumns: "1fr 1fr",
      gap: 50,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    },
    num: { 
      fontWeight: "bold",
      fontSize: "5.8rem",
      fontFamily: "philosopher",
      letterSpacing: "0px",
      margin: "0rem",
      "-webkit-text-fill-color": "transparent", /*Will override color (regardless of order) */
      " -webkit-text-stroke": " 1.5px #63718A",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "4.5rem",
      },
    },
    achievementCardWrapper: {
      display: 'grid',
      gap: 20,
    },
    subTitle:{
      color: theme.palette.text.primary,
      marginBottom: "0.8rem",
    },
    masonryWrapper:{
      width: "100%",
      // gap: 20,
      margin: "2rem 0",
      boxSizing: 'border-box',
      [theme.breakpoints.down("md")]: {
        columns: 2,
      },
      [theme.breakpoints.down("sm")]: {
        columns: 1,
      },
      columns: 3,
      height: 'fit-content !important',
    },
  };
}